import React, { FC, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IButtonProps {
  cb: (cb: any) => void;
  cls: string;
  icon?: any;
  text: string;
  type?: 'prompt';
  disabled?: boolean;
  color?: string;
}

export const Button: FC<IButtonProps> = memo(({ cb, cls, icon, text, type, disabled, color }) => {
  return type === 'prompt' ? (
    <button type="button" onClick={cb} className={cls} title={text}>
      {icon && <FontAwesomeIcon icon={icon} color={color || ''} />}
    </button>
  ) : (
    <button type="button" value={text} disabled={disabled} className={cls} key={text} onClick={cb}>
      {text}
    </button>
  );
});
